import React from 'react'
import { connect } from 'react-redux'
import { values } from 'lodash'
import moment from 'moment'
import { createSelector } from 'reselect'

import {
  Modal
} from 'react-bootstrap'

import Button from '../components/Button.jsx'
import { rejectTrigger } from '../actions/ui.js'
import { initiatePlan } from '../ducks/tasks'
import getPlansList from '../tasks/plans.js'
import { getAllTasks } from '../selectors'
import { getText } from '../lib/text'

/**
 * selectors
 */

const getTriggeredTrip = state => (state.ui.planTriggers.length ? state.ui.planTriggers[0].trip : null)

const triggeredTripTasks = createSelector(
  [getTriggeredTrip, getAllTasks],
  (tripId, allTasks) => (
    (tripId && values(allTasks).filter(t => t.trip == tripId)) || []
  )
)

const triggeredTripTasksFromPlan1 = createSelector(
  [triggeredTripTasks], tasks => tasks.filter(t => t.plan == "plan1")
)

/**
 *
 */

type Props = {
  trip: Object,
  nextTrigger: null | { plan: string, trip: string },
  hasTasksFromPlan1: boolean,
  reject: (string, string) => void,
  accept: (string, string, string) => void,
}

class PlanTriggerModal extends React.PureComponent
{
  props: Props

  render() {
    if (!this.props.nextTrigger) return null

    const { trip, reject, accept } = this.props
    const plan = getPlansList()[this.props.nextTrigger.plan]
    const hasPlan1 = this.props.hasTasksFromPlan1

    return (
      <Modal show onHide={() => this.props.reject()}>
        <Modal.Header>
          <Modal.Title>
            {getText("¿Activar plan en este viaje?")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{getText("plan_trigger_question_1")} {trip.realName || trip.name || getText("Cliente sin nombre")}{getText("plan_trigger_question_2")}: </p>
          <ul><li><strong>{plan.name}:</strong> {plan.text}</li></ul>
          {
            hasPlan1 && (
              <p style={{color:"#bd3a04"}}>{getText("¡El plan ya ha sido iniciado para este cliente!")}</p>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <em style={{fontSize: 12, marginRight: 10}}>
            {getText('(Puedes iniciarlo a mano en "Tareas > Iniciar plan")')}
          </em>
          <Button
            bsStyle={hasPlan1 ? "default" : "primary"}
            onClick={() => accept(trip._id, plan.id, trip.encargado)}
          >
            {getText("Sí, iniciar plan")}
          </Button>
          <Button
            bsStyle={hasPlan1 ? "primary" : "default"}
            onClick={() => reject(trip._id, plan.id)}
          >
            {getText("No, no iniciar por ahora")}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const stateToProps = (state, props) => ({
  nextTrigger: state.ui.planTriggers[0] || null,
  trip: state.ui.planTriggers.length > 0 ? state.trips[state.ui.planTriggers[0].trip] : null,
  hasTasksFromPlan1: triggeredTripTasksFromPlan1(state, props).length > 0
})

const dispatchToProps = dispatch => ({
  reject: (tripId, planId) => dispatch(rejectTrigger(tripId, planId)),
  accept: (tripId, planId, encargado) => dispatch(initiatePlan(tripId, planId, encargado, moment().format("YYYY/MM/DD")))
})

export default connect(stateToProps, dispatchToProps)(PlanTriggerModal)
